import React from 'react';
import { motion } from 'framer-motion';
import { Phone, PhoneOff, Video, X } from 'lucide-react';

const IncomingCallModal = ({ caller, callType, onAccept, onReject }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 bg-black/80 flex items-center justify-center z-[100]"
      style={{ pointerEvents: 'auto' }}
    >
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.8, opacity: 0 }}
        className="bg-gradient-to-br from-[#3B82F6] to-[#8B5CF6] rounded-3xl shadow-2xl p-8 max-w-md w-full text-center text-white"
        style={{ pointerEvents: 'auto' }}
      >
        <div className="mb-6">
          <motion.div
            animate={{ scale: [1, 1.1, 1] }}
            transition={{ repeat: Infinity, duration: 1.5 }}
            className="w-24 h-24 mx-auto rounded-full overflow-hidden border-4 border-white shadow-lg mb-4"
            style={{ background: '#E5E7EB' }}
          >
            {caller.avatar ? (
              <img src={caller.avatar} alt={caller.name} className="w-full h-full object-cover" />
            ) : (
              <div className="w-full h-full flex items-center justify-center text-4xl font-bold" style={{ color: '#6B7280' }}>
                {caller.name.charAt(0).toUpperCase()}
              </div>
            )}
          </motion.div>
          
          <h2 className="text-2xl font-bold mb-2">{caller.name}</h2>
          <p className="text-white/80 text-lg flex items-center justify-center gap-2">
            {callType === 'video' ? <Video className="w-5 h-5" /> : <Phone className="w-5 h-5" />}
            Incoming {callType === 'video' ? 'Video' : 'Voice'} Call
          </p>
        </div>

        <div className="flex gap-4 justify-center">
          <motion.button
            data-testid="reject-call-button"
            onClick={onReject}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="w-16 h-16 rounded-full bg-red-500 flex items-center justify-center shadow-lg"
          >
            <PhoneOff className="w-8 h-8 text-white" />
          </motion.button>
          
          <motion.button
            data-testid="accept-call-button"
            onClick={onAccept}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="w-16 h-16 rounded-full bg-green-500 flex items-center justify-center shadow-lg"
          >
            <Phone className="w-8 h-8 text-white" />
          </motion.button>
        </div>

        <p className="mt-6 text-sm text-white/60">Ringing...</p>
      </motion.div>
    </motion.div>
  );
};

export default IncomingCallModal;